import { render, staticRenderFns } from "./BackgroundControl.vue?vue&type=template&id=1d14fe84&scoped=true&"
import script from "./BackgroundControl.vue?vue&type=script&lang=js&"
export * from "./BackgroundControl.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundControl.vue?vue&type=style&index=0&id=1d14fe84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d14fe84",
  null
  
)

export default component.exports